import React from 'react';

import { ButtonsContainer } from './SignUpButtons.styled';
import { Envelope } from 'assets/icons/Icons';
import { GoogleAuthButton } from 'components/GoogleAuthButton';
import { Button } from 'components/v2/Buttons/Button/Button';
import { analytics } from 'utilities/analytics';

import { Props } from './SignUpButton.types';

export const SignUpButtons = (props: Props) => {
  const { onSignUpWithEmail } = props;

  return (
    <ButtonsContainer>
      <GoogleAuthButton context="signup" />
      <Button
        label="Continue with Email"
        category="secondary"
        size="sm"
        fullWidth
        leftIcon={<Envelope type="solid" />}
        onClick={() => {
          onSignUpWithEmail();
          analytics.track(analytics.EVENTS.SIGN_UP_STARTED_EMAIL);
        }}
      />
    </ButtonsContainer>
  );
};
